import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import { WidgetsSharedConfigState } from 'widgets/store/sharedConfiguration/WidgetsSharedConfigState';
import { ThunkDispatch } from 'store/store';
import { Layout, LayoutVersions } from 'layout/LayoutState';
import { UIComponentConfiguration } from 'layout/uiConfiguration';
import { LoggingService } from '@instinet-analytics/core-lib';
import { AnyAction } from 'redux';
import upgradeLayoutToVersion2 from 'layout/upgrade/upgradeLayoutToVersion2';
import upgradeLayoutToVersion3 from 'layout/upgrade/upgradeLayoutToVersion3';
import { WidgetType } from 'widgets/WidgetType';

export interface UpgradeLayoutOptions {
    loggingService: LoggingService;
    dispatch: ThunkDispatch<AnyAction>;
    appSettings: AppSettingsState;
    components: { [p: string]: UIComponentConfiguration };
    sharedWidgetConfigs: WidgetsSharedConfigState;
    layout: Layout;
}

export type UpgradeLayoutFn = (options: UpgradeLayoutOptions) => void;

const NullUpgrade: UpgradeLayoutFn = () => {
    return;
};

const upgrades: UpgradeLayoutFn[] = [
    NullUpgrade,
    upgradeLayoutToVersion2,
    upgradeLayoutToVersion3,
];

export default function upgradeLayout(options: UpgradeLayoutOptions) {
    const { layout, loggingService } = options;
    const currentVersion = layout.version ?? 0;
    const nextVersion = LayoutVersions.length;

    if (currentVersion === nextVersion) {
        return;
    }

    for (let vsn = currentVersion; vsn < nextVersion; vsn++) {
        if (upgrades[vsn]) {
            upgrades[vsn](options);
        }
    }

    loggingService.debug(
        'upgradeLayout',
        `Upgraded layout ${layout.name}/${layout.id} from version ${currentVersion} to ${nextVersion}`
    );
    layout.version = nextVersion;
}

export function getNextUniqueKey(widgetType: WidgetType, widgetKeys: string[]) {
    let nextId = 0;
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // Increment until we find an unused id...
        const nextKey = `${widgetType}-${nextId}`;
        const existsInLayout = widgetKeys.indexOf(nextKey) > -1;

        if (!existsInLayout) {
            return nextKey;
        }
        nextId++;
    }
}
